import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import axios from 'axios';
import { Button } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:10000";

function CreateFreeAccount() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [expirationDate, setExpirationDate] = useState('');
    const [platform, setPlatform] = useState('iOS');
    const [tier, setTier] = useState('2');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const generatePassword = () => {
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
        let newPassword = "";
        for (let i = 0, n = charset.length; i < 12; ++i) {
            newPassword += charset.charAt(Math.floor(Math.random() * n));
        }
        setPassword(newPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);
        setError(null);

        if (!name || !email || !username || !expirationDate || !password) {
            setError("Please fill out all fields.");
            setLoading(false);
            return;
        }

        try {
            // Append :00Z to make the datetime-local input a valid ISO-8601 string in UTC for the backend
            const isoDate = new Date(expirationDate).toISOString();

            const formData = new URLSearchParams();
            formData.append('name', name);
            formData.append('email', email);
            formData.append('password', password);
            formData.append('tier', tier);
            formData.append('username', username);
            formData.append('expiration_date', isoDate);
            formData.append('platform', platform);
            formData.append('subscription_method', 'Created by Automated Free Access');
            formData.append('isFoundersClub', 'true');
            formData.append('mailChimpOptIn', 'false');

            const response = await axios.post(`${API_BASE_URL}/verification/createNewFreeAccessAcount`, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            if (response.status === 200) {
                setMessage("Free Account Created successfully!");
                // Clear form
                setName('');
                setEmail('');
                setUsername('');
                setExpirationDate('');
                setPlatform('iOS');
                setTier('2');
                setPassword('');
            } else {
                setError("Failed to create account: " + response.data);
            }
        } catch (err) {
            console.error(err);
            if (err.response && err.response.data) {
                setError(typeof err.response.data === 'string' ? err.response.data : "An error occurred");
            } else {
                setError(err.message);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="App">
            <Navbar />
            <div style={{ padding: '40px', maxWidth: '600px', margin: '0 auto', textAlign: 'left' }}>
                <h3>Create Free Account</h3>
                <br />
                {message && <div style={{ padding: '10px', backgroundColor: '#d4edda', color: '#155724', marginBottom: '15px', borderRadius: '5px' }}>{message}</div>}
                {error && <div style={{ padding: '10px', backgroundColor: '#f8d7da', color: '#721c24', marginBottom: '15px', borderRadius: '5px' }}>{error}</div>}
                
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div>
                        <label>Name:</label>
                        <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} required />
                    </div>
                    <div>
                        <label>Email:</label>
                        <input type="email" className="form-control" value={email} onChange={e => setEmail(e.target.value)} required />
                    </div>
                    <div>
                        <label>Username:</label>
                        <input type="text" className="form-control" value={username} onChange={e => setUsername(e.target.value)} required />
                    </div>
                    <div>
                        <label>Expiration Date:</label>
                        <input type="datetime-local" className="form-control" value={expirationDate} onChange={e => setExpirationDate(e.target.value)} required />
                    </div>
                    <div>
                        <label>Platform:</label>
                        <select className="form-control" value={platform} onChange={e => setPlatform(e.target.value)}>
                            <option value="iOS">iOS</option>
                            <option value="Android">Android</option>
                        </select>
                    </div>
                    <div>
                        <label>Tier:</label>
                        <select className="form-control" value={tier} onChange={e => setTier(e.target.value)}>
                            <option value="0">Admin & CMS Access (Tier 0)</option>
                            <option value="1">Basic (Tier 1)</option>
                            <option value="2">Pro (Tier 2)</option>
                        </select>
                    </div>
                    <div>
                        <label>Password:</label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <input type="text" className="form-control" value={password} onChange={e => setPassword(e.target.value)} required />
                            <Button appearance="ghost" onClick={generatePassword} type="button">Generate</Button>
                        </div>
                    </div>
                    <div style={{ marginTop: '20px' }}>
                        <Button appearance="primary" color="green" type="submit" disabled={loading} block>
                            {loading ? 'Creating...' : 'Create Account'}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateFreeAccount;
